import { RootState } from "../..";
import { BannerEvent, BannerEventState } from "./types";

export const selectBannerEvent = (state: RootState): BannerEventState => state.public.bannerEvent;
export const selectBannerEventLoading = (state: RootState): boolean => state.public.bannerEvent.status === 'loading';
export const selectBannerEventData = (state: RootState): BannerEvent[] => state.public.bannerEvent.data.data.items;